const ShipmentAdditionalColumns = [
  "created",
  "pickup_city",
  "stop1_city",
  "dangerous_goods",
  "total_weight_kg",
  "total_weight_lbs",
  "total_volume_cbm",
  "quoted_delivery_datetime",
  "quoted_pickup_datetime",
  "export_clearance",
  "transit_clearance",
  "import_clearance",
  "service_requirement",
  "incoterms",
  "insurance",
  "tracking_number_added",
  "mbl_number",
  "container_number",
  "MAWB_number",
  "primary_tracking",
  "custom_field_01",
  "custom_field_02",
  "custom_field_03",
  "contracted",
  "reason_code",
  "cost_center",
  "pol_eta",
  "pol_locode",
  "pod_eta",
  "pod_locode",
  "pod_time",
  "origin",
  "delivery",
  "destination_name",
  "origin_name",
  "confirmation_datetime",
  "expected_pickup_datetime",
  "expected_delivery_datetime",
  "vessel_imo",
  "truck_number",
  "related_shipments_count",
  "team_name",
] as const;

export default ShipmentAdditionalColumns;
